<template>
    <div class="flex mt-8">
        <svg-icon :type="iconByType" class="w-18 h-18" :class="textColor"></svg-icon>
        <p class="font-normal" :class="textColor">
            {{message}}
            <slot></slot>
        </p>
    </div>
</template>

<script>
import SvgIcon from './SvgIcon.vue';
export default {
    components: {
        SvgIcon
    },
    props: {
        message: {
            type: String,
            default: ''
        },
        icon: String,
        type: {
            type: String,
            default: 'info'
        },
    },
    computed: {
        iconByType() {
            if (this.icon) return this.icon;
            switch (this.type) {
                case 'info':
                    return 'info-rounded';
                case 'warning':
                    return 'warning';
                case 'error':
                    return 'error';
                case 'success':
                    return 'success';
                default:
                    return 'info-rounded';
            }
        },
        textColor() {
            switch (this.type) {
                case 'info':
                    return 'text-[#086D8E]';
                case 'warning':
                    return 'text-orange';
                case 'error':
                    return 'text-[#FF0000]';
                case 'success':
                    return 'text-[#008000]';
                default:
                    return 'text-[#334076]';
            }
        }
    }
}
</script>